import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import StakeholderMap from './stakeholdersMap/components/StakeholderMap.vue';
import RiskMap from './riskMap/RiskMap.vue';
import Home from './Home.vue';
import LandingPage from './LandingPage.vue';
import Callback from './Callback.vue';
import Login from './Login.vue';
import { authState, authMethods } from './stores/auth.ts';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'Landing',
    component: LandingPage,
    meta: { isRoot: true, requiresAuth: false }
  },
  {
    path: '/home',
    name: 'LandingHome',
    component: LandingPage,
    meta: { isRoot: true, requiresAuth: false }
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: Home,
    meta: { isRoot: true, requiresAuth: true }
  },
  {
    path: '/stakeholder-map',
    name: 'Stakeholders Map',
    component: StakeholderMap,
    meta: { isRoot: false, requiresAuth: true }
  },
  {
    path: '/risk-map',
    name: 'Risks Map',
    component: RiskMap,
    meta: { isRoot: false, requiresAuth: true }
  },
  {
    path: '/callback',
    name: 'Callback',
    component: Callback,
    meta: { isRoot: false }
  },
  {
    path: '/login',
    name: 'GraphRM',
    component: Login,
    meta: { isRoot: true }
  }
];

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Router guard to handle authentication
router.beforeEach(async (to, _from, next) => {
  // If route requires auth, check authentication first
  if (to.meta.requiresAuth) {
    // Ensure auth state is refreshed
    await authMethods.refresh();
    
    if (!authState.isAuthenticated) {
      next({ path: '/login' });
      return;
    }
  }
  
  next();
});
